export default __webpack_public_path__ + "static/media/csalad.4aa08cf2.png";